import { IDocumentSource } from "./IDocumentSource";
import { DocumentReference } from "./DocumentReference";

export class DocumentSummaryHistory extends DocumentReference {
  // 変数名は暫定
  constructor(
    id: number,
    patientNo: string,
    edition: number,
    previewSource: IDocumentSource,
    printSource: IDocumentSource,
    isPrintable: boolean,
    public archiveId: number,
    public departmentName: string,
    public createDateTime: Date,
    public createOperatorName: string,
    public createOperatorProfessionName: string,
    public updateDateTime: Date,
    public updateOperatorName: string,
    public published: boolean,
    public isTemporary: boolean,
    public isLatest: boolean,
    public isDeleted: boolean,
    public isFixed: boolean,
    public defaultCopies: number,
    public documentName: string,
    public isQuotable: boolean,
    public alternativeFormatOriginalId: number,
    isUnmanaged: boolean,
    public note: string,
    public isWritable: boolean,
    public isVirtual: boolean,
    public orderUserName: string,
    public attendingUserName: string,
  ) {
    super(id, patientNo, edition, previewSource, printSource, isPrintable, defaultCopies, isUnmanaged);
  }
}
